export default __webpack_public_path__ + "static/media/MazdaTrans.83af10f0.png";